import { render } from "./CallingTimezoneManagementList.vue?vue&type=template&id=40bf63d4&scoped=true"
import script from "./CallingTimezoneManagementList.vue?vue&type=script&lang=js"
export * from "./CallingTimezoneManagementList.vue?vue&type=script&lang=js"

import "./CallingTimezoneManagementList.vue?vue&type=style&index=0&id=40bf63d4&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bf63d4"]])

export default __exports__